import { CardType } from 'app/ui-components/ContentList/ContentList';
import PropTypes from 'prop-types';
import React from 'react';
import ContentItemCarousel from '../../ui-components/ContentItemCarousel/ContentItemCarousel';
import { PlaceHolder } from '../../ui-components/PlaceHolder/PlaceHolder';
import { Heading, StyledRecommendations } from './Recommendations.styles';

const RecommendationsContainer = ({ header, className, children }) => (
    <StyledRecommendations className={className} data-helix-type="list" aria-label={header || 'Tips för dig'}>
        <Heading as="h2">{header || 'Tips för dig'}</Heading>
        {children}
    </StyledRecommendations>
);

export const Loading = ({ className, header }) => (
    <RecommendationsContainer className={className} header={header}>
        <PlaceHolder nrOfItems={6} />
    </RecommendationsContainer>
);

const Recommendations = ({ items, header, className, onItemClick, onItemImpression }) => {
    if (!items || items.length === 0) {
        return null;
    }

    return (
        <RecommendationsContainer header={header} className={className}>
            <ContentItemCarousel
                id="not-found-recommendations"
                items={items}
                editModeActivated={false}
                onItemClick={onItemClick}
                onItemImpression={onItemImpression}
                cardType={CardType.SHOWCASE}
            />
        </RecommendationsContainer>
    );
};

Recommendations.propTypes = {
    items: PropTypes.array,
    header: PropTypes.string,
    className: PropTypes.string,
    onItemClick: PropTypes.func,
    onItemImpression: PropTypes.func,
};

export default Recommendations;
